import { render } from "./ImprintPage.vue?vue&type=template&id=74568a26&scoped=true&ts=true"
import script from "./ImprintPage.vue?vue&type=script&lang=ts"
export * from "./ImprintPage.vue?vue&type=script&lang=ts"

import "./ImprintPage.vue?vue&type=style&index=0&id=74568a26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74568a26"]])

export default __exports__